import { render, staticRenderFns } from "./IndustrialTalents.vue?vue&type=template&id=00da438f"
import script from "./IndustrialTalents.vue?vue&type=script&lang=js"
export * from "./IndustrialTalents.vue?vue&type=script&lang=js"
import style0 from "./IndustrialTalents.vue?vue&type=style&index=0&id=00da438f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports